var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCustomers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99612 4C4.99612 2.89543 5.89323 2 6.99987 2C8.10651 2 9.00362 2.89543 9.00362 4C9.00362 5.10457 8.10651 6 6.99987 6C5.89323 6 4.99612 5.10457 4.99612 4ZM6.99987 0C4.78659 0 2.99238 1.79086 2.99238 4C2.99238 5.4288 3.74291 6.68263 4.87193 7.39014C2.08928 8.44915 0.181777 11.5286 0.00141725 14.9474C-0.0287656 15.5195 0.427007 16 0.999935 16H13.0001C13.573 16 14.0288 15.5195 13.9986 14.9474C13.8182 11.5285 11.9106 8.44903 9.12791 7.39008C10.2569 6.68255 11.0074 5.42876 11.0074 4C11.0074 1.79086 9.21315 0 6.99987 0ZM2.72221 14C2.41051 14 2.17381 13.7171 2.25219 13.4155C2.80933 11.2711 4.19149 9.72912 5.78368 9.20026L6.58491 10L5.58304 12.4142L6.9999 13.8284L8.41676 12.4142L7.41489 10L8.21618 9.20021C9.80842 9.72902 11.1907 11.2711 11.7478 13.4155C11.8262 13.7171 11.5895 14 11.2778 14H2.72221Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/customers.b292721a.svg";
export { ForwardRef as ReactComponent };